// This file contains all experience level constants used in the application

export const EXPERIENCE_LEVELS = Object.freeze([
    { value: 'Beginner', labelKey: 'home.experienceLevels.beginner' },
    { value: 'Intermediate', labelKey: 'home.experienceLevels.intermediate' },
    { value: 'Moderate', labelKey: 'home.experienceLevels.moderate' },
    { value: 'Advanced', labelKey: 'home.experienceLevels.advanced' },
    { value: 'Expert', labelKey: 'home.experienceLevels.expert' },
]);

export const EXPERIENCE_LEVEL_LABEL_MAP = EXPERIENCE_LEVELS.reduce((acc, level) => {
    acc[level.value] = level.labelKey;
    return acc;
}, {});

export default EXPERIENCE_LEVELS;
